import React, { Component } from 'react';
import './css/index.scss';
import { Link } from 'react-router-dom';


class SearchResults extends Component {
  
  constructor(props){
    super(props);
    this.state = {
    };
  }

  componentDidMount(){
  }

  getArtists = () => {
    return this.props.searchResults.artists.map((artist) => {
        return <Link key={`srA${artist.id}`} onClick={() => {this.props.clearSearch()}} className="resultLink" to={`/artist/${artist.slug}`}>{artist.name}</Link>
    });
  }

  getTabs = () => {
    return this.props.searchResults.tabs.map((tab) => {
        return <Link key={`srT${tab.id}`} onClick={() => {this.props.clearSearch()}} className="resultLink" to={`/tabulatura/${tab.id}/${tab.artist.name.replace(/\s+/g, '-')}/${tab.title.replace(/\s+/g, '-')}`}>{tab.title} ({tab.artist.name})</Link>
    });
  }

  render () {
    return (
        
        <div className="searchResults">
            <div className="sRLeft">
                <h2 id={'ah'}>Artiști</h2>
                <div>
                {this.getArtists()}
                </div>
            </div>
            <div className="sRRight">
            <h2 id={'at'}>Tabulaturi</h2>
            <div>
              {this.getTabs()}
            </div>
            </div>
        </div> 
        
    ); 
  }
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/searchResults/searchResults.js